// Generated by ts-to-zod
import { z } from 'zod';
import { urlSchema } from '../../utils/codecUtils.schema';

export const createHookInterfacePayloadSchema = z.object({
  hook: urlSchema,
  name: z.string(),
  description: z.string(),
  payload: z.record(z.unknown()),
  metadata: z.record(z.unknown()),
  type: z.string(),
});
